/**
 * Dashboard presenter'i
 */

import { AppState } from '../../modules/state.js';
import { APP_CONFIG } from '../../firebase-config.js';
import { DashboardService } from './dashboard.service.js';
import { formatDate, formatNumber } from '../../shared/utils/formatters.js';

interface DashboardPresenterDeps {
    escapeHtml: (value: string) => string;
}

export function updateOverviewStatsPresenter(): void {
    const stats = DashboardService.getOverviewStats();

    const totalApartments = document.getElementById('total-apartments');
    const paidDues = document.getElementById('paid-dues');
    const unpaidDues = document.getElementById('unpaid-dues');
    const totalBalance = document.getElementById('total-balance');

    if (totalApartments) totalApartments.textContent = String(stats.totalApartments);
    if (paidDues) paidDues.textContent = String(stats.paidDues);
    if (unpaidDues) unpaidDues.textContent = String(stats.unpaidDues);
    if (totalBalance) totalBalance.textContent = `₺${formatNumber(stats.totalBalance)}`;
}

export function updateOverviewAlertsPresenter(): void {
    const container = document.getElementById('overview-alerts');
    if (!container) return;

    const year = AppState.currentYear;
    const currentMonth = new Date().getMonth() + 1;
    let unpaidCount = 0;

    for (let apartment = 1; apartment <= APP_CONFIG.TOTAL_APARTMENTS; apartment++) {
        if (!AppState.dues[year]?.[apartment]?.[currentMonth]) {
            unpaidCount++;
        }
    }

    const pendingTasks = AppState.tasks.filter(task => task.status !== 'completed').length;
    const maintenanceSoon = AppState.maintenance.filter(item => {
        if (item.status === 'completed') return false;
        const dayDiff = Math.ceil((new Date(item.date).getTime() - Date.now()) / 86400000);
        return dayDiff <= 14;
    }).length;

    const alerts = [
        { icon: '💰', title: 'Aidat Takibi', value: `${unpaidCount} daire`, desc: 'Bu ay ödemesi eksik', target: 'dues' },
        { icon: '📋', title: 'Açık İşler', value: `${pendingTasks} kayıt`, desc: 'Tamamlanmayı bekliyor', target: 'tasks' },
        { icon: '🔧', title: 'Yakın Bakım', value: `${maintenanceSoon} kayıt`, desc: '14 gün içinde planlı', target: 'maintenance' }
    ];

    container.innerHTML = alerts.map(alert => `
        <button class="overview-alert-card" type="button" data-target="${alert.target}">
            <span class="overview-alert-icon">${alert.icon}</span>
            <span class="overview-alert-info">
                <strong>${alert.title}</strong>
                <span class="overview-alert-value">${alert.value}</span>
                <span class="overview-alert-desc">${alert.desc}</span>
            </span>
            <span class="overview-alert-arrow">→</span>
        </button>
    `).join('');
}

export function renderUpcomingMaintenancePresenter(deps: DashboardPresenterDeps): void {
    const container = document.getElementById('upcoming-maintenance');
    if (!container) return;

    const upcoming = DashboardService.getUpcomingMaintenance(3);
    if (upcoming.length === 0) {
        container.innerHTML = '<p class="empty-state">Yaklaşan bakım yok</p>';
        return;
    }

    container.innerHTML = upcoming.map(item => `
        <div class="recent-item">
            <h4>🔧 ${deps.escapeHtml(item.title)}</h4>
            <p>${formatDate(item.date)}</p>
        </div>
    `).join('');
}
